"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BT018_UPDATE_DELIVERY_POINT_ERROR = exports.BT018_RESUME_ORDER_ERROR = exports.BT018_CONFIRM_SHADOW_BASKET_ERROR = exports.BT018_DEFAULT_ERROR = void 0;
exports.BT018_DEFAULT_ERROR = {
    title: 'Victime de son succès',
    text: 'Un ou plusieurs produits présents dans votre panier sont victimes de leur succès et ne sont plus disponibles.',
    buttons: [
        {
            label: 'Voir mon panier', route: { name: 'basket' }
        }
    ],
    handle: function (resp) {
        var _a, _b, _c;
        var error = (_c = (_b = (_a = resp.data) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.globals) === null || _c === void 0 ? void 0 : _c[0];
        var products = (error === null || error === void 0 ? void 0 : error.products) || [__assign({}, (error === null || error === void 0 ? void 0 : error.metadata) || {})];
        if (!products || products.length === 0) {
            return {
                title: 'Victime de son succès',
                text: 'Un ou plusieurs produits présents dans votre panier sont victimes de leur succès et ne sont plus disponibles.',
            };
        }
        var productsName = products.map(function (product) { return "\"".concat(product.boxName || product.name, "\""); }).join(', ');
        if (products.length === 1) {
            return {
                title: 'Victime de son succès',
                text: "Le produit <b>".concat(productsName, "</b> vient d'\u00EAtre vendu et n\u2019est d\u00E9sormais plus disponible."),
            };
        }
        else if (products.length > 1) {
            return {
                title: 'Victime de son succès',
                text: "Les produits <b>".concat(productsName, "</b> viennent d'\u00EAtre vendus et ne sont d\u00E9sormais plus disponibles."),
            };
        }
        else {
            return {
                title: 'Victime de son succès',
                text: 'Un ou plusieurs produits présents dans votre panier sont victimes de leur succès et ne sont plus disponibles.',
            };
        }
    }
};
exports.BT018_CONFIRM_SHADOW_BASKET_ERROR = {
    title: 'Victime de son succès', text: 'Le dernier élément vient d\'être vendu et n’est désormais plus disponible.',
};
exports.BT018_RESUME_ORDER_ERROR = {
    title: 'Victime de son succès', text: "Votre commande ne peut malheureusement pas \u00EAtre reprise car tous les \u00E9l\u00E9ments pr\u00E9sents\n      sont \u00E9puis\u00E9s. Nous vous sugg\u00E9rons de faire une nouvelle commande \u00E0 partir des paniers propos\u00E9s\n      et disponibles cette semaine.",
    buttons: [
        {
            label: 'Aller sur la boutique', route: { name: 'dashboard' },
        }
    ],
};
exports.BT018_UPDATE_DELIVERY_POINT_ERROR = {
    title: 'Victime de son succès',
    text: 'Un produit présent dans votre panier est victime de son succès  et n\'est plus disponible pour le jour de livraison choisi. Si vous souhaitez appliquer ce changement, nous devront le retirer de votre panier.',
};
exports.default = {
    default: exports.BT018_DEFAULT_ERROR,
    'ShadowBasketApi.confirm': exports.BT018_CONFIRM_SHADOW_BASKET_ERROR,
    'ShadowBasketApi.addProduct': exports.BT018_CONFIRM_SHADOW_BASKET_ERROR,
    'UserApi.resumeOrder': exports.BT018_RESUME_ORDER_ERROR,
    'TemporaryCustomerApi.setBasketDeliveryPoint': exports.BT018_UPDATE_DELIVERY_POINT_ERROR,
    'UserApi.setBasketDeliveryPoint': exports.BT018_UPDATE_DELIVERY_POINT_ERROR,
};
//# sourceMappingURL=BT018Handler.js.map